import { removeEmail, removeToken } from ".";

export const removeAuthTokens = (): void => {
    removeToken("auth_token");
    removeToken("refresh_token");
    removeEmail();
};
